module.exports = __webpack_public_path__ + "img/active-qingdan.d7d2db4e.png";